<template>
	<Form ref="formValidate" :model="formValidate" :label-width="110" :label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="app应用" :label-width="80">
				<Select v-model="appId" style="width:200px" @on-change="changeApp">
					<Option v-for="item in apps" :value="item.appKey" :key="item.appKey">{{ item.appName }}
					</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="创建日期" prop="dateRange">
				<DatePicker type="daterange" v-model="formValidate.dateRange" :options="dateRangeOptions"
					format="yyyy/MM/dd" placement="bottom-end" placeholder="请选择" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="一级分类" :label-width="100">
				<Select v-model="formValidate.pageName" style="width:200px" @on-change="changePage" clearable>
					<Option v-for="item in pageNames" :value="item" :key="item">{{ item }}
					</Option>
				</Select>
			</FormItem>
			</Col>
			<Col v-if="showEvent" :md="6" :sm="12" :xs="24">
			<FormItem label="事件" :label-width="80">
				<Select v-model="formValidate.eventName" style="width:200px" clearable>
					<Option v-for="item in events" :value="item" :key="item">{{ item }}
					</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="12" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 0px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
				<Button type="success" @click="exportExcel" icon="ios-cloud-download-outline"
					style="margin: 0 8px 16px 16px;">导出数据</Button>
			</FormItem>
			</Col>

		</Row>
	</Form>

</template>
<script>
	import api from '../../api'
	import { mapGetters } from 'vuex'
	import { STATISTICS_START_TIME, LINK_TYPES } from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {
			showEvent: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				apps: [],
				pageNames: [],
				events: [],
				appId: '',				
				formValidate: {
					dateRange: [],
					pageName: '',
					eventName: ''
				},
				dateRangeOptions: {
					disabledDate(date) {
						const startDate = new Date(STATISTICS_START_TIME).getTime()
						const now = Date.now()
						return (
							date && !(date.valueOf() >= startDate && date.valueOf() <= now)
						)
					}
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {
			//获取全部app
			api.statistics
				.getAppPage({ page: 1, limit: 100 })
				.then(res => {
					this.apps = res.data.records
					if (this.apps.length > 0) {
						this.appId = this.apps[0].appKey
					}
				}).then(res => {
					if (this.appId) {
						//获取一级分类
						api.statistics
							.getAllPageName({ appKey: this.appId })
							.then(res => {
								this.pageNames = res.data
							})
					}
				})
		},
		methods: {
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			exportExcel() {
				this.$emit('exportExcel', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					dateRange: [],
				}
				//this.formSubmit()
			},
			getFormData() {

				const formData = { ...this.formValidate,appId:this.appId }
				return formData
			},
			changeApp() {
				api.statistics
					.getAllPageName({ appKey: this.appId })
					.then(res => {
						this.formValidate.pageName=''
						this.formValidate.eventName=''
						this.pageNames = res.data
					})
			},
			changePage() {
				this.formValidate.eventName=''
				if (this.showEvent) {
					if(!this.formValidate.pageName){
						this.events=[]
						return
					}
					//获取事件
					api.statistics
						.getPageEventName({ appKey: this.appId, pageName: this.formValidate.pageName })
						.then(res => {
							this.events = res.data
						})
				}
			}
		}
	}
</script>
